<template>
  <v-stepper
    v-if="!loading"
    v-model="currentStep"
    alt-labels
    class="checkout stepper-checkout"
  >
    <v-stepper-header>
      <template v-for="step in steps">
        <v-stepper-step
          :key="`${step.step}-step`"
          :color="color"
          :complete="currentStep > step.step"
          :step="`${step.step}`"
        >
        </v-stepper-step>
        <v-divider v-if="step.step !== steps.length" :key="step.step" />
      </template>
    </v-stepper-header>
    <v-stepper-items>
      <v-row>
        <v-col class="pa-md-3" cols="12" md="8">
          <v-stepper-content step="1" class="pa-0">
            <Step1
              :term-use="termUse"
              :modal-term-use="modalTermUse"
              @setTermUse="handleSetTermUse"
            />
          </v-stepper-content>
          <v-stepper-content step="2" class="pa-0">
            <Step2 :apigetplanprices="getPlanPrices" />
          </v-stepper-content>
          <v-stepper-content step="3" class="pa-0">
            <Step3 />
          </v-stepper-content>
          <v-stepper-content step="4" class="pa-0">
            <Step4 />
          </v-stepper-content>
          <v-stepper-content step="5" class="pa-0">
            <Step5 />
          </v-stepper-content>
          <FooterCheckout
            :current-step="currentStep"
            :step-validation="stepValidation"
            :loading="loading"
            @changeStep="handleChangeStep"
            @nextStep="handleNextStep"
          />
        </v-col>
        <v-col
          v-if="currentStep !== 5"
          style="z-index: 99; background-color: #fff"
          class="abstract pa-0 pa-md-3"
          cols="12"
          md="4"
        >
          <div class="abstract-content">
            <Abstract @changePlan="getPlanPrices" />
            <v-row class="ma-0 mt-6">
              <v-col cols="12" class="d-flex align-center">
                <p class="ma-0 pa-0 mr-2" style="font-size: 14px">
                  Surgiu alguma dúvida? Fale com a gente:
                </p>
                <v-btn
                  class="mx-2"
                  small
                  fab
                  :href="contact_whatsapp"
                  target="_blank"
                  @click="$analytics('contact_checkout', 'click ', 'whatsapp')"
                >
                  <v-img
                    :src="
                      require('@/assets/images/materialicons/whatsapp-white.svg')
                    "
                    contain
                    max-width="24"
                  />
                </v-btn>
                <v-btn
                  class="mx-2"
                  small
                  fab
                  :href="contact_email"
                  @click="$analytics('contact_checkout', 'click ', 'email')"
                >
                  <v-img
                    :src="
                      require('@/assets/images/materialicons/email-white.svg')
                    "
                    contain
                    max-width="24"
                  />
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <PaymentDrawer
          :show-drawer="showPaymentDrawer"
          @closePaymentDrawer="handleClosePaymentDrawer"
          @openSucessoDrawer="handleOpenSucessoDrawer"
        />
        <SucessoDrawer
          :show-drawer="showSucessoDrawer"
          @closeSucessoDrawer="handleCloseSucessoDrawer"
        />
      </v-row>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import CheckoutProvider from '@/providers/CheckoutProvider';
import Iugu from '@/providers/Iugu';
import PLANPRICES_CONST from '@/constants/PlanPrices';

export default {
  name: 'Checkout',
  metaInfo: {
    title: 'Checkout',
  },
  components: {
    SucessoDrawer: () => import('@/components/Checkout/SucessoDrawer.vue'),
    Abstract: () => import('@/components/Checkout/Abstract.vue'),
    Step1: () => import('@/components/Checkout/Step1.vue'),
    Step2: () => import('@/components/Checkout/Step2.vue'),
    Step3: () => import('@/components/Checkout/Step3.vue'),
    Step4: () => import('@/components/Checkout/Step4.vue'),
    Step5: () => import('@/components/Checkout/Step5.vue'),
    FooterCheckout: () => import('@/components/Checkout/FooterCheckout.vue'),
    PaymentDrawer: () => import('@/components/Checkout/PaymentDrawer.vue'),
  },
  data() {
    return {
      postLead: false,
      loading: true,
      paymentError: false,
      signupError: false,
      modalTermUse: false,
      contact_whatsapp: PLANPRICES_CONST.CONTACT_WHATSAPP,
      contact_email: PLANPRICES_CONST.CONTACT_EMAIL,
      steps: [
        {
          step: 1,
          description: 'PRÉ-REGISTRO',
        },
        {
          step: 2,
          description: 'PERCENTUAL',
        },
        {
          step: 3,
          description: 'MATERIAL',
        },
        {
          step: 4,
          description: 'REGIÃO',
        },
        {
          step: 5,
          description: 'RESUMO',
        },
      ],
      plan_identifier: this.$route.query.plan
        ? this.$route.query.plan
        : 'feather',
      color: '#26D07C',
      showPaymentDrawer: false,
      showSucessoDrawer: false,
    };
  },
  computed: {
    termUse() {
      return this.$store.getters.getTermUse;
    },
    currentStep() {
      return this.$store.getters.getCurrentValidation;
    },
    stepValidation() {
      return this.$store.getters.getStepValidation;
    },
    liabilityPercentage() {
      return this.$store.getters.liabilityPercentage;
    },
    regionCoverage() {
      return this.$store.getters.regionCoverage;
    },
    leadForm() {
      return this.$store.getters.getLeadForm;
    },
    organization() {
      return this.$store.getters.getOrganization;
    },
    companyForm() {
      return this.$store.getters.getCompanyForm;
    },
    getCompanyBranches() {
      return this.$store.getters.getCompanyBranches;
    },
    organizationRepresentantForm() {
      return this.$store.getters.getOrganizationRepresentantForm;
    },
    paymentForm() {
      return this.$store.getters.getPaymentForm;
    },
    materials() {
      return this.$store.getters.materials;
    },
  },
  watch: {
    currentStep() {
      if (this.currentStep === 2) {
        this.$router.replace({
          path: '/checkout',
          query: { plan: this.$route.query.plan, passo: '02' },
        });
      }
      if (this.currentStep === 3) {
        this.$router.replace({
          path: '/checkout',
          query: { plan: this.$route.query.plan, passo: '03' },
        });
      }
      if (this.currentStep === 4) {
        this.$router.replace({
          path: '/checkout',
          query: { plan: this.$route.query.plan, passo: '04' },
        });
      }
      if (this.currentStep === 5) {
        this.$router.replace({
          path: '/checkout',
          query: { plan: this.$route.query.plan, passo: '05' },
        });
      }
    },
  },
  beforeMount() {
    if (!this.$route.query.plan) {
      this.$router.push('/nossos-precos');
    }
    Iugu.loadScript();
  },
  mounted() {
    this.getPlanPrices();
    this.checkClass();

    window.addEventListener('scroll', () => {
      const content = document.querySelector('.v-stepper__items');
      const abstract = document.querySelector('.abstract-content');
      if (content !== null && abstract !== null) {
        const result = content.scrollHeight - (abstract.scrollHeight + 30);

        if (result <= window.pageYOffset) {
          abstract.classList.add('hide');
        } else if (abstract.classList.contains('hide')) {
          abstract.classList.remove('hide');
        }
      }
    });
  },
  methods: {
    async getPlanPrices(promocode = null) {
      try {
        this.$store.commit('setIsLoading', true);

        const plan = this.$route.query.plan
          ? this.$route.query.plan
          : 'feather';

        const resPlan = await CheckoutProvider.getPlans(plan, { promocode });
        this.$store.commit('planData', resPlan.data);
        this.loading = false;
        this.$store.commit('setIsLoading', false);
      } catch (err) {
        console.error(err);
      }
    },
    handleSetTermUse(checked) {
      this.$store.commit('setTermUse', checked);
    },
    handleChangeStep(step) {
      this.$store.commit('changeStep', step);
      this.scrollTop();
    },
    handleNextStep(step) {
      const validationStep = {
        validationStep1: async () => {
          if (this.stepValidation.step1) {
            try {
              const res = await this.postLeadForm();

              if (res) {
                this.$analytics('pricing_steps', 'preregister_lead');
                this.handleChangeStep(1);
              }
            } catch (err) {
              console.error(err);
            }
          }
        },
        validationStep2: () => {
          if (this.stepValidation.step2) {
            this.handleChangeStep(2);
          }
        },
        validationStep3: () => {
          if (this.stepValidation.step3) this.handleChangeStep(1);
        },
        validationStep4: async () => {
          if (this.stepValidation.step4) {
            // Captura a lista de associações

            if (this.$store.getters.containMS) {
              await CheckoutProvider.associations().then(res => {
                this.$store.commit('setAssociationList', res.data.data);
              });
            }
            this.handleChangeStep(1);
          }
        },
        validationStep5: async () => {
          if (this.stepValidation.step5) {
            this.showPaymentDrawer = true;
            this.$router.replace({
              path: '/checkout',
              query: { plan: this.$route.query.plan, passo: 'pagamento' },
            });
          }
        },
      };

      const validateFunction = validationStep[`validationStep${step}`];
      validateFunction();
    },
    async postLeadForm() {
      if (this.currentStep === 1 && !this.postLead) {
        // await CheckoutProvider.postRegisterLead(this.leadForm);
        return true;
      }
      return false;
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    checkClass() {
      if (document.querySelector('.new-color')) {
        this.color = '#26d07c';
      }
    },
    handleClosePaymentDrawer() {
      this.showPaymentDrawer = false;
    },
    handleCloseSucessoDrawer() {
      this.showSucessoDrawer = false;
      window.location.href = window.location.origin;
    },
    handleOpenSucessoDrawer() {
      this.showSucessoDrawer = true;
      this.$router.replace({
        path: '/checkout',
        query: { plan: this.$route.query.plan, passo: 'pagamento-sucesso' },
      });
    },
  },
};
</script>

<style lang="sass">
.stepper-checkout
  padding-top: 80px
  -webkit-box-shadow: none
  box-shadow: none
  height: 100% !important

  .v-stepper__label
    display: none

  .v-stepper__header
    -webkit-box-shadow: none
    box-shadow: none
    background-color: transparent
    font-size: 0
    .v-divider
      border-color: #A8A8AD !important
      border-width: 4px
      margin: 34px -75px 0
      z-index: 1
      @media screen and (max-width: 959px)
        margin: 34px -45px 0
  .v-stepper__items
    @media screen and (min-width: 960px)
      padding: 0 4%
    > .row
      position: relative
      @media screen and (max-width: 959px)
        flex-flow: column-reverse

  .v-stepper__step
    flex-basis: 158px !important
    @media screen and (max-width: 959px)
      flex-basis: 70px !important
    &:not(.v-stepper__step--complete)
      .v-stepper__step__step
        background: #CDCDD0 !important
    &.v-stepper__step--complete
      .v-stepper__step__step
        background: #26D07C !important
        &:before
          background: #003036
        .v-icon
          display: none
      +.v-divider
        border-color: #003036 !important
        border-top-right-radius: 4px
        border-bottom-right-radius: 4px
    .v-stepper__step__step
      font-size: 0
      color: transparent
      height: 28px
      min-width: 28px
      width: 28px
      margin-bottom: 0
      &:before
        background: #A8A8AD
        content: ''
        position: relative
        display: block
        width: 16px
        height: 16px
        border-radius: 24px

.abstract
  @media screen and (max-width: 959px)
    margin-bottom: 50px

.v-menu__content
  z-index: 101 !important

.new-color
  .stepper-checkout,
  .v-select-list
    font-family: 'metropolisregular', sans-serif !important

.v-label
  color: #72737A
  font-size: 14px
.v-text-field.v-text-field--enclosed:not(.v-input--checkbox) > .v-input__control > .v-input__slot
  box-shadow: none !important
  border: 2px solid #A8A8AD
  border-radius: 5px
</style>

<style scoped lang="sass">
@import '@/styles/util'
@import '@/styles/style'
@import '@/styles/checkout'
</style>

<style lang="sass">
@import '@/styles/checkout'

.useterms
  .v-input__slot
    margin: 0
  .v-messages
    display: none
</style>
